<template>
  <div 
    :class="{'bg-black-05':!hasTracks}" 
    class="tracks-container overflow-y-scroll pa1 h-100 textColor">

    <div v-show="loading" class="flex justify-center items-center h5">
      <pulse-loader 
      :loading="loading" 
      :color="color" 
      :size="size">
      </pulse-loader>
    </div>

    <p v-show="!loading & !hasTracks" class="pa2 center tc textColor">El artista no tiene tracks</p>
    <div class="bb b--black-05 pa1 flex justify-between ma0 relative" v-for="track in artistTracks"
          :track-by="track.id"
          :key="track.id"
          :class="{'track-playing' : track == currentTrack}">
      <a @click="setPlaylist(artistTracks);changeTrack(track)" class="dim db mr3 w-100"
          :class="{'pointer': track !== currentTrack}">
        <div class="track-container flex items-center flex-start">
          <div class="image-container ml-2">
            <track-image :track="track"></track-image>
          </div>
          <div class="flex justify-between w-100">
              <track-data :track="track" class="fw6 info-container textColor"></track-data>
              <p class="mv2 f7 textColor">{{track.seconds | time}}</p>
            </div>
        </div>
      </a>
      <track-options-button :track="track"/>
    </div>
  </div>
</template>

<script>
  import TrackData from '@/components/tracks/TrackData'
  import TrackImage from '@/components/tracks/TrackImage'
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  import TrackOptionsButton from '@/components/tracks/TrackOptionsButton.vue'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'artist-tracks',
    components: {
      TrackData,
      TrackImage,
      PulseLoader,
      TrackOptionsButton
    },
    data () {
      return {
        color: '#808080',
        size: '10px'
      }
    },
    created () {
      if (this.artistTracks.length === 0 && this.artist.id !== undefined) {
        this.getArtistTracks(this.artist.id).catch((e) => {
          this.$toasted.show(this.error.message, {type: 'error'})
        })
      }
    },
    computed: {
      ...mapGetters('artist', [
        'artistTracks',
        'artist',
        'error'
      ]),
      ...mapGetters('player', [
        'currentTrack'
      ]),
      hasTracks () {
        return this.artistTracks.length > 0
      },
      loading () {
        return this.$loading.isLoading('artist getArtistTracks')
      }
    },
    methods: {
      ...mapActions('artist', [
        'getArtistTracks'
      ]),
      ...mapActions('player', [
        'setPlaying',
        'setPlaylist',
        'changeTrack'
      ])
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .tracks-container {
    overflow-x: hidden;
  }

  .track-container {
    flex-grow: 1;
  }

  .image-container {
    height: 50px;
    width: 50px;
    min-height: 50px;
    min-width: 50px;
    max-height: 50px;
    max-width: 50px;
  }

  .track-data /deep/ p {
    font-size: .75rem;
  }

  .info-container {
    width: 25vw;
    max-width: 25vw;
    min-width: 25vw;
  }

  @media screen and (max-width: 780px) {
    .info-container {
      width: 35vw;
      max-width: 35vw;
      min-width: 35vw;
    }
  }

  @media screen and (max-width: 479px) {
    .image-container {
      min-height: 30px;
      min-width: 30px;
      max-height: 350px;
      max-width: 30px;
      height: 30px;
      width: 30px;
    }
    .info-container {
      width: 45vw;
      max-width: 45vw;
      min-width: 45vw;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/artistProfile/ArtistTracks.vue